export default function isDebug() {
    return process.env.REACT_APP_DEBUG === "true"
}